import React from 'react';
import {Route} from 'react-router-dom';

import {BookPage} from './bookPage';

/** Renders routes to book a meeting for use as children on a react-router Switch. */
export const bookRoutes = (
  <Route key="book" path="/:subdomain/:username/:schedulingLinkAlias" element={<BookPage />} />
);
